import {createContext, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import app from "../../firebase";

const UserContext = createContext();

function UserContextProvider({ children }) {
    const [user, setUser] = useState();
    const auth = getAuth(app);

    onAuthStateChanged(auth,
        (u) => {
            setUser(u);
        }
    )

    return (
        <UserContext.Provider value={user}>
            { children }
        </UserContext.Provider>
    )
}

export default UserContext;
export {UserContextProvider};